import { HStack, Modal, ModalContent, ModalOverlay, Spinner } from "@chakra-ui/react";
import { forwardRef, useCallback, useImperativeHandle, useState } from "react";

const LoadingModal = (props: any, ref: any) => {
  const [showModal, setShowModal] = useState(false);

  const open = useCallback(() => {
    setShowModal(true);
  }, []);
  const close = useCallback(() => {
    setShowModal(false);
  }, []);
  useImperativeHandle(ref, () => ({
    open: () => open(),
    close: () => close(),
  }));
  return (
    <Modal isOpen={showModal} onClose={close}>
      <ModalOverlay />
      <ModalContent height={"80vh"} width={"100vw"} display={"flex"} justifyContent={"center"} alignItems={"center"} bg={"transparent"}>
        <HStack
          gap={2}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Spinner size={"xl"} color="white" />
        </HStack>
      </ModalContent>
    </Modal>
  );
};

export default forwardRef(LoadingModal);
  